import React, { Fragment, FC, ChangeEvent } from 'react';
import { compose } from 'recompose';
import { connect, FormikProps } from 'formik';
import { Grid, Switch, Typography } from '@material-ui/core';
import { createStyles, withStyles, Theme, WithStyles } from '@material-ui/core/styles';

import { SocialAccountIcon } from 'components';

import { INetwork, IShare } from '../types';
import Commentary from './Commentary';

interface IProps {
  network: INetwork;
  onRemove: () => void;
}

interface IPropsEnhanced extends IProps, WithStyles<typeof styles> {
  formik: FormikProps<IShare>;
}

const styles = (theme: Theme) =>
  createStyles({
    switch: {
      right: -theme.spacing(2),
    },
  });

const enhancers = compose<IPropsEnhanced, IProps>(connect, withStyles(styles));

const ActiveUnauth: FC<IPropsEnhanced> = ({ classes, formik, network, onRemove }) => {
  const { values } = formik;
  const { provider } = network;

  const item = values[provider];
  const { active } = item;

  function toggleNetwork(event: ChangeEvent<HTMLInputElement>) {
    formik.setFieldValue(`${network.provider}.active`, event.target.checked);
  }

  return (
    <Fragment>
      <Grid container alignItems="center" justify="space-between">
        <Grid item>
          <Grid container>
            <Grid item>
              <SocialAccountIcon active={active} provider={provider} />
            </Grid>
            <Grid item>
              <Typography variant="subtitle2">{network.name}</Typography>
            </Grid>
          </Grid>
        </Grid>
        <Grid item>
          <Switch checked={active} className={classes.switch} onChange={toggleNetwork} />
        </Grid>
      </Grid>
      <Commentary network={network} />
    </Fragment>
  );
};

export default enhancers(ActiveUnauth);
